// @ts-strict-ignore
import * as React from 'react';

import Grid from 'components/grid';
import PlaylistGridItem from 'components/pages/playlists/playlist-grid-item';
import { Heading } from 'components/typography';

import type { Playlist } from 'api';
import { FormattedMessage } from 'react-intl';

type PlaylistsGridProps = {
  playlists: Playlist[];
  error: Error | null;
};

function PlaylistsGrid({
  playlists,
  error
}: PlaylistsGridProps): React.ReactNode {
  if (error) {
    return (
      <div className="mb-14 pt-6 md:mb-20 md:pt-12 lg:mb-40 lg:pt-28">
        <Heading size="xl" className="mb-6 text-black">
          <FormattedMessage defaultMessage="Sorry, something went wrong." />
        </Heading>
        <Heading size="m" className="text-gray-700">
          <FormattedMessage defaultMessage="Please try again." />
        </Heading>
      </div>
    );
  }

  return playlists?.length > 0 ? (
    <Grid>
      {playlists.map((playlist, index) => {
        return (
          <PlaylistGridItem
            playlist={playlist}
            key={`${playlist.title}-${index}`}
          />
        );
      })}
    </Grid>
  ) : (
    <div className="mb-14 pt-6 md:mb-20 md:pt-12 lg:mb-40 lg:pt-28">
      <Heading size="xl" className="mb-6 text-black">
        <FormattedMessage defaultMessage="Sorry. We couldn't find a playlist quite like that." />
      </Heading>
      <Heading size="m" className="text-gray-700">
        <FormattedMessage defaultMessage="Looks like there weren't any playlists matching your search criteria." />
      </Heading>
      <Heading size="m" className="text-gray-700">
        <FormattedMessage defaultMessage="You can try using a more general term or searching with fewer filters." />
      </Heading>
    </div>
  );
}

export default PlaylistsGrid;
